import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.css';
import { Checkbox } from '../Checkbox/Checkbox';
import { NumericInput } from '../NumericInput/NumericInput';

export const CheckboxStepperField = ({
  checkboxName,
  numericInputName,
  checkboxLabel,
  numericMin = 0,
  numericMax,
  numericStep = 1,
  disabled,
  values,
  inputClassName,
  onInputChange,
}) => {
  const isCheckboxChecked = values?.[checkboxName];
  
  // const inputValue = values?.[numericInputName];
  // if (disabled && inputValue === 0) {
  //   isCheckboxChecked = false;
  // }

  // const onNumericChange = (event) => {
  //   console.log('Numeric input changed', event);
  //   onInputChange(event);
  // };

  return (
    <div className={styles.selRow}>
      <label className={styles.checkbox}>
        {/* <Checkbox
          name={checkboxName}
          checked={isCheckboxChecked}
          disabled={disabled}
        /> */}
        <span className={styles.checkboxLabel}>{checkboxLabel}</span>
      </label>

      <NumericInput
        name={numericInputName}
        min={numericMin}
        max={numericMax}
        step={numericStep}
        disabled={disabled}
        myClassName={inputClassName}
        onChange={onInputChange}
      />
    </div>
  );
};

CheckboxStepperField.propTypes = {
  checkboxName: PropTypes.string.isRequired,
  numericInputName: PropTypes.string.isRequired,
  checkboxLabel: PropTypes.string.isRequired,
  numericMin: PropTypes.number,
  numericMax: PropTypes.number,
  numericStep: PropTypes.number,
  disabled: PropTypes.bool,
  values: PropTypes.object.isRequired,
  inputClassName: PropTypes.string,
};
